/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess } from "../../clients/courseRegistrationEnrollmentController/putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess.ts";

export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationKey =
  () =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/course-access",
      },
    ] as const;

export type PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationKey =
  ReturnType<
    typeof putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationKey
  >;

export function putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationKey();
  return mutationOptions<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500
    >,
    {
      courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"];
      data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ courseRegistrationId, data }) => {
      return putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess(
        courseRegistrationId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Atualiza as configurações de acesso ao curso. Quando liberado com ReleasedUntil, o acesso expira ao fim do dia informado. Quando liberado sem ReleasedUntil, o acesso expira após ReleasedDays dias (padrão 30). A data de liberação não pode ser menor que hoje. Quando bloqueado, limpa todos os campos de liberação. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Salva o acesso ao curso de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/course-access}
 */
export function usePutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
      ResponseErrorConfig<
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500
      >,
      {
        courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"];
        data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationKey();

  const baseOptions =
    putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationOptions(
      config,
    ) as UseMutationOptions<
      PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
      ResponseErrorConfig<
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500
      >,
      {
        courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"];
        data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500
    >,
    {
      courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"];
      data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500
    >,
    {
      courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams["courseRegistrationId"];
      data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest;
    },
    TContext
  >;
}
